import React, { useState, useEffect, useCallback, useRef, useMemo, useContext } from 'react';
import { useParams, useHistory, Prompt } from 'react-router-dom';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCar, 
  faMapMarkerAlt, 
  faShare, 
  faUtensils, 
  faBed, 
  faUmbrellaBeach, 
  faTasks, 
  faCog, 
  faCompass,
  faLink,
  faWallet,
  faListCheck,
  faClone,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import { 
  faWhatsapp, 
  faXTwitter 
} from '@fortawesome/free-brands-svg-icons';
import { getItineraryById, updateItinerary, getAmenities, deleteItinerary, cloneItinerary, createCustomActivity, getCustomActivities, updateCustomActivity, deleteCustomActivity, cloneCustomActivity, updateItineraryPOI, addPOIToTrip, clonePOI } from '../services/api';
import Navbar from '../components/Navbar';
import ErrorBoundary from '../components/ErrorBoundary';
import Toast from '../components/Toast';
import TripMap from '../components/TripMap';
import POIDetails from '../components/POIDetails';
import ResizablePOICard from '../components/ResizablePOICard';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import styles from '../styles/pages/TripDetailsPage.module.css';
import styled from 'styled-components';
import { format, addDays, differenceInDays, startOfMonth, startOfDay, isSameDay } from 'date-fns';
import { keyframes } from 'styled-components';
import _ from 'lodash';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { CSSTransition } from 'react-transition-group';
import CustomActivityModal from '../components/CustomActivityModal';
import SettingsModal from '../components/SettingsModal';
import CustomActivityDetailsModal from '../components/CustomActivityDetailsModal';
import ItineraryMap from '../components/ItineraryMap';
import { AuthContext } from '../contexts/AuthContext';
import VerticalAdBanner from '../components/AdPlaceholder';
import BudgetOverviewModal from '../components/BudgetOverviewModal';
import ChecklistModal from '../components/ChecklistModal';
import AuthModal from '../components/AuthModal';

import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { es, enUS } from 'date-fns/locale';

// Add these with your other styled components
const EmptyTimeSlot = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  cursor: pointer;
  min-height: 60px;

  &:hover .ghost-card {
    opacity: 1;
  }
`;

const GhostCard = styled.div`
  position: absolute;
  top: 5px;
  left: 60px;
  right: 10px;
  height: calc(100% - 10px);
  background-color: rgba(0, 0, 0, 0.1);
  border: 2px dashed #666;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: #666;
  font-size: 0.9em;
  padding: 10px;
  text-align: center;
`;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f7f9;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 100vh;
  background: #f5f7f9;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    height: auto;
    padding: 0 10px;
  }
`;

const MapAndHeaderContainer = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  gap: 20px;
  min-width: 600px;
  max-width: 500px;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    padding: 10px 0;
    min-width: unset;
  }
`;

const HeaderSection = styled.div`
  flex: 0.5;
  min-height: 120px;
  max-height: 120px;
  width: 100%;
  background: white;
  border-radius: 16px;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  @media (max-width: 768px) {
    flex: none;
    padding: 10px;
  }
`;

const MapSection = styled.div`
  flex: 2.5;
  position: relative;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    height: 27vh;
  }
`;

const MapWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const ItinerarySection = styled.div`
  flex: 2;
  min-width: 600px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 20px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    min-width: unset;
    height: 55vh;
    padding: 10px;
    margin-left: 0;
  }
`;

const FloatingButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: white;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: scale(1.1);
  }

  &:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    left: 120%;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    white-space: nowrap;
  }
`;

const SharePopup = styled.div`
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 10px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  padding: 10px;
  display: flex;
  gap: 10px;
  z-index: 1100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

const PrivateMessage = styled.div`
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 10px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 1100;
  width: max-content;
`;

const ShareButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 1.0rem;
  padding: 5px;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  position: relative;

  &:hover {
    color: #333;
  }

  &:hover ${SharePopup} {
    opacity: 1;
    visibility: visible;
  }

  &:hover ${PrivateMessage} {
    opacity: 1;
    visibility: visible;
  }
`;

const SocialIcon = styled.button`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-size: 1.2rem;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  &.whatsapp {
    background-color: #25D366;
  }

  &.twitter {
    background-color: #000000;
  }

  &.email {
    background-color: #4285F4;
  }

  &.copy {
    background-color: #6c757d;
  }
`;

const HeaderContainer = styled.div`
  padding: 20px;
  background-color: white;
  position: relative;
  border-radius: 16px;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: relative;
  padding-right: 100px;
  max-width: 100%;
`;

const TripTitle = styled.h1`
  font-size: 24px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding-right: 10px;
  position: relative;
  cursor: pointer;
`;

const SubtitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

const TripDateRange = styled.p`
  font-size: 14px;
  color: #666;
  margin: 5px 0;
`;

const TripActivities = styled.span`
  font-size: 14px;
  color: #666;
  margin-left: 10px;

  &::before {
    content: '|';
    margin-right: 10px;
  }
`;

const SettingsContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 10px;
  z-index: 11;
`;

const SettingsButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 5px;
  transition: color 0.3s ease;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #333;
  }
`;

const ScrollableContent = styled.div`
  height: calc(100vh - 200px);
  overflow-y: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    height: calc(70vh - 120px);
  }
`;

const TimeSlot = styled.div`
  position: relative;
  height: 60px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
`;

const TimeSlotHeader = styled.div`
  width: 60px;
  flex-shrink: 0;
  padding: 5px;
  color: #888;
  font-size: 0.7rem;
  font-weight: normal;
  text-align: center;
`;

const POIContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const DaySelectorContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 10px 0;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const DaySelector = styled.div`
  display: inline-flex;
  gap: 10px;
  padding: 0 10px;
`;

const DayButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: ${props => props.selected ? '#316C6E' : 'white'};
  color: ${props => props.selected ? 'white' : '#316C6E'};
  border: 1px solid #316C6E;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9em;

  &:hover {
    background-color: ${props => props.selected ? '#316C6E' : '#f0f8ff'};
  }
`;

const MonthAbbr = styled.span`
  font-size: 0.8em;
  text-transform: uppercase;
`;

const DayNumber = styled.span`
  font-size: 1.2em;
  font-weight: bold;
`;

const DatePickerContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  padding: 20px;
  margin-top: 10px;
  
  .rdp {
    --rdp-cell-size: 40px;
    --rdp-accent-color: #0066cc;
    --rdp-background-color: #e6e6e6;
    margin: 0;
  }

  .rdp-months {
    justify-content: center;
  }

  .rdp-month {
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px;
  }

  .rdp-day_selected, .rdp-day_selected:focus-visible, .rdp-day_selected:hover {
    background-color: var(--rdp-accent-color);
    color: white;
  }

  &.calendar-enter {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  
  &.calendar-enter-active {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  
  &.calendar-exit {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  
  &.calendar-exit-active {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
`;

const ConfirmModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
`;

const ConfirmContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
`;

const ConfirmButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 10px 20px;
  margin: 0 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: white;
  background-color: ${props => props.danger ? '#dc3545' : '#007bff'};

  &:hover {
    background-color: ${props => props.danger ? '#c82333' : '#0056b3'};
  }
`;

const RightAdContainer = styled.div`
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  
  @media (max-width: 1200px) {
    display: none;
  }
`;

const MapAndItineraryContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-left: 20px;
`;

const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    color: #316C6E;
    transform: translateY(-2px);
  }

  svg {
    font-size: 14px;
  }

  &::before {
    content: '|';
    color: #666;
    margin-right: 20px;
  }

  &:first-child::before {
    content: none;
  }
`;

const TripDetailsPage = () => {
  const { id } = useParams();
  const [itinerary, setItinerary] = useState(null);
  const [title, setTitle] = useState('');
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingDates, setIsEditingDates] = useState(false);
  const [openDays, setOpenDays] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [selectedPOI, setSelectedPOI] = useState(null);
  const [deletedPOIs, setDeletedPOIs] = useState([]);
  const [timeSlots, setTimeSlots] = useState({});
  const [currentDay, setCurrentDay] = useState(1);
  const dayRefs = useRef({});
  const daysSectionRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef(null);
  const [selectedDay, setSelectedDay] = useState(1);
  const [amenities, setAmenities] = useState([]);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(null);
  const [editingPOI, setEditingPOI] = useState(null);
  const popupRef = useRef(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const history = useHistory();
  const mapContainerRef = useRef(null);
  const [originalItinerary, setOriginalItinerary] = useState(null);
  const [shouldCenterDays, setShouldCenterDays] = useState(false);
  const daySelectorRef = useRef(null);
  const calendarRef = useRef(null);
  const [calendarPOI, setCalendarPOI] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showCustomActivityModal, setShowCustomActivityModal] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [customActivities, setCustomActivities] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingChanges, setPendingChanges] = useState(null);
  const scrollableContentRef = useRef(null);
  const [hasInitialScrolled, setHasInitialScrolled] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [settingsTitle, setSettingsTitle] = useState('');
  const [settingsDateRange, setSettingsDateRange] = useState({ from: null, to: null });
  const [showDeletePOIModal, setShowDeletePOIModal] = useState(false);
  const [poiToDelete, setPoiToDelete] = useState(null);
  const [selectedCustomActivity, setSelectedCustomActivity] = useState(null);
  const [settingsIsPublic, setSettingsIsPublic] = useState(false);
  const [toastType, setToastType] = useState('success');
  const [isReadOnly, setIsReadOnly] = useState(false);
  const { isAuthenticated, user, login } = useContext(AuthContext);
  const [showBudgetModal, setShowBudgetModal] = useState(false);
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const { language } = useLanguage();
  const t = translations[language].pages.tripDetails;

  // Add this function near the top of the component, with other utility functions
  const getCurrentTripDay = (startDate) => {
    const today = new Date();
    const start = new Date(startDate);
    
    // Reset time parts to compare just the dates
    today.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    
    // Calculate the difference in days
    const diffTime = today.getTime() - start.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    // Add 1 because trip days are 1-based
    return diffDays + 1;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [itineraryData, amenitiesData] = await Promise.all([
          getItineraryById(id),
          getAmenities()
        ]);
        console.log('Fetched itinerary data:', itineraryData);
        
        setItinerary(itineraryData);
        setOriginalItinerary(_.cloneDeep(itineraryData));
        setTitle(itineraryData.name);
        setSettingsIsPublic(itineraryData.isPublic);
        setIsReadOnly(itineraryData.isReadOnly);
        const start = new Date(itineraryData.start_date);
        const end = new Date(itineraryData.end_date);
        setDateRange({ from: start, to: end });
        setAmenities(amenitiesData);

        // Calculate which day to show by default
        const currentTripDay = getCurrentTripDay(start);
        const totalDays = getTotalDays(start, end);
        
        // If current day is within trip dates, show that day, otherwise show day 1
        const defaultDay = (currentTripDay > 0 && currentTripDay <= totalDays) 
          ? currentTripDay 
          : 1;
        
        setSelectedDay(defaultDay);
        setCurrentDay(defaultDay);

        const initialOpenDays = {};
        for (let i = 1; i <= getTotalDays(start, end); i++) {
          initialOpenDays[i] = true;
        }
        setOpenDays(initialOpenDays);
      } catch (error) {
        console.error('Error fetching data:', error);
        setToastMessage('Failed to load trip. Please try again.');
        setShowToast(true);
      }
    };
    fetchData();
  }, [id, user?.id]);

  useEffect(() => {
    const fetchCustomActivities = async () => {
      try {
        const response = await getCustomActivities(id);
        setCustomActivities(response.data || []);
      } catch (error) {
        console.error('Error fetching custom activities:', error);
        setCustomActivities([]);
      }
    };
    fetchCustomActivities();
  }, [id]);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
    setCurrentDay(1);
  }, []);

  useEffect(() => {
    const scrollToDay = (day) => {
      const dayElement = dayRefs.current[day];
      if (dayElement) {
        const headerHeight = headerRef.current ? headerRef.current.offsetHeight : 0;
        const yOffset = -headerHeight - 20; // 20px extra space
        const y = dayElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    };

    if (selectedDay) {
      scrollToDay(selectedDay);
    }
  }, [selectedDay]);

  const getTotalDays = useCallback((startDate, endDate) => {
    if (!startDate || !endDate) return 0;
    return Math.ceil((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)) + 1;
  }, []);

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    if (isReadOnly) {
      setToastMessage('This operation is only allowed for the owner of the trip, clone this trip if you want to make your own changes');
      setToastType('warning');
      setShowToast(true);
      return;
    }

    const sourceDay = parseInt(result.source.droppableId.split('-')[1]);
    const destDay = parseInt(result.destination.droppableId.split('-')[1]);
    const sourceHour = parseInt(result.source.droppableId.split('-')[2]);
    const destHour = parseInt(result.destination.droppableId.split('-')[2]);

    setItinerary(prevItinerary => {
      const newPois = [...prevItinerary.pois];
      const [movedItem] = newPois.splice(
        newPois.findIndex(item => item.uniqueKey === result.draggableId),
        1
      );

      movedItem.day = destDay;
      movedItem.hour = destHour;

      newPois.splice(result.destination.index, 0, movedItem);

      newPois.sort((a, b) => {
        if (a.day !== b.day) return a.day - b.day;
        if (a.hour !== b.hour) return a.hour - b.hour;
        return a.order - b.order;
      }).forEach((item, index) => {
        item.order = index;
      });

      // Save changes immediately
      (async () => {
        try {
          if (movedItem.isCustom) {
            await updateCustomActivity(prevItinerary.id, movedItem.id, {
              day: destDay,
              hour: destHour,
              order: result.destination.index
            });
          } else {
            await updateItineraryPOI(prevItinerary.id, movedItem.id, {
              day: destDay,
              hour: destHour,
              order: result.destination.index
            });
          }
          setToastMessage('Activity moved successfully');
          setShowToast(true);
        } catch (error) {
          console.error('Error updating activity position:', error);
          setToastMessage('Failed to update activity position. Please try again.');
          setShowToast(true);
        }
      })();

      return { ...prevItinerary, pois: newPois };
    });
  };

  const toggleDay = (day) => {
    setOpenDays(prev => ({ ...prev, [day]: !prev[day] }));
  };

  const handleTitleClick = () => {
    setIsEditingTitle(true);
  };

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    setTitle(newTitle);
    setHasChanges(true);
    setHasUnsavedChanges(true);
  };

  const handleTitleBlur = async () => {
    if (title !== itinerary.name) {
      try {
        await updateItinerary(id, { name: title });
        setItinerary(prev => ({ ...prev, name: title }));
        setToastMessage(t.toast.titleUpdated);
        setShowToast(true);
      } catch (error) {
        console.error('Error updating title:', error);
        setToastMessage(t.toast.titleError);
        setShowToast(true);
        setTitle(itinerary.name);
      }
    }
    setIsEditingTitle(false);
  };

  const handleDateChange = (range) => {
    if (range?.from && range?.to) {
      setDateRange(range);
    }
  };

  const handleClickOutside = useCallback((event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setIsDatePickerOpen(false);
      if (dateRange.from && dateRange.to) {
        handleSaveDates();
      }
    }
  }, [dateRange]);

  const handleSaveDates = async () => {
    try {
      await updateItinerary(id, { start_date: dateRange.from, end_date: dateRange.to });
      setItinerary(prev => ({ ...prev, start_date: dateRange.from, end_date: dateRange.to }));
      setToastMessage('Dates updated successfully');
      setShowToast(true);
    } catch (error) {
      console.error('Error updating dates:', error);
      setToastMessage('Failed to update dates. Please try again.');
      setShowToast(true);
      setDateRange({ from: new Date(itinerary.start_date), to: new Date(itinerary.end_date) });
    }
  };

  useEffect(() => {
    if (isDatePickerOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDatePickerOpen, handleClickOutside]);

  const reorganizePOIs = useCallback((newStartDate, newEndDate) => {
    console.log('Reorganizing POIs:', newStartDate, newEndDate);
    const newTotalDays = getTotalDays(newStartDate, newEndDate);
    const currentTotalDays = getTotalDays(dateRange.from, dateRange.to);

    if (newTotalDays < currentTotalDays) {
      setItinerary(prev => {
        const newPOIs = prev.pois.map(poi => {
          if (poi.day > newTotalDays) {
            return { ...poi, day: newTotalDays };
          }
          return poi;
        });
        return { ...prev, pois: newPOIs };
      });
    }
  }, [getTotalDays, dateRange]);

  const checkForChanges = useCallback(() => {
    if (!originalItinerary || !itinerary) return false;

    if (
      originalItinerary.name !== title ||
      (dateRange.from && dateRange.to && (
        new Date(originalItinerary.start_date).getTime() !== dateRange.from.getTime() ||
        new Date(originalItinerary.end_date).getTime() !== dateRange.to.getTime()
      ))
    ) {
      return true;
    }

    const originalPOIs = originalItinerary.pois || [];
    const currentPOIs = itinerary.pois || [];

    if (originalPOIs.length !== currentPOIs.length) return true;

    for (let i = 0; i < originalPOIs.length; i++) {
      const original = originalPOIs[i];
      const current = currentPOIs[i];

      if (
        original.id !== current.id ||
        original.day !== current.day ||
        original.hour !== current.hour ||
        original.duration !== current.duration ||
        original.order !== current.order
      ) {
        return true;
      }
    }

    return false;
  }, [originalItinerary, itinerary, title, dateRange]);

  useEffect(() => {
    if (originalItinerary && itinerary && dateRange.from && dateRange.to) {
      setHasChanges(checkForChanges());
    }
  }, [itinerary, title, dateRange, checkForChanges, originalItinerary]);

  const handleSaveChanges = async () => {
    try {
      const updatedItinerary = {
        ...itinerary,
        name: title,
        start_date: dateRange.from,
        end_date: dateRange.to,
        pois: itinerary.pois.filter(poi => !poi.isCustom),
        customActivities: customActivities
      };
      await updateItinerary(id, updatedItinerary);
      setOriginalItinerary(_.cloneDeep(updatedItinerary));
      setHasChanges(false);
      setIsEditingTitle(false);
      setIsEditingDates(false);
      setToastMessage('Trip saved successfully');
      setShowToast(true);
      setHasUnsavedChanges(false);
    } catch (error) {
      console.error('Error saving trip:', error);
      setToastMessage('Failed to save trip. Please try again.');
      setShowToast(true);
    }
  };

  const calculateDrivingTime = useCallback((poi1, poi2) => {
    if (!poi1 || !poi2) return '';
    const R = 6371;
    const dLat = (poi2.lat - poi1.lat) * Math.PI / 180;
    const dLon = (poi2.lng - poi1.lng) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(poi1.lat * Math.PI / 180) * Math.cos(poi2.lat * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const distance = R * c;
    const timeInMinutes = Math.round(distance / 50 * 60);
    const hours = Math.floor(timeInMinutes / 60);
    const minutes = timeInMinutes % 60;
    return `${hours > 0 ? `${hours}h ` : ''}${minutes}min`;
  }, []);

  const calculateTotalDrivingTime = useCallback(() => {
    if (!itinerary) return '0h 0min';
    
    let totalMinutes = 0;
    const sortedPOIs = sortPOIs(itinerary.pois);

    for (let i = 0; i < sortedPOIs.length - 1; i++) {
      const time = calculateDrivingTime(sortedPOIs[i], sortedPOIs[i + 1]);
      const [hours, minutes] = time.split('h ');
      totalMinutes += parseInt(hours || 0) * 60 + parseInt(minutes);
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}min`;
  }, [itinerary, calculateDrivingTime]);

  const sortPOIs = useCallback((pois) => {
    return [...pois].sort((a, b) => {
      if (a.day !== b.day) return a.day - b.day;
      if (a.hour !== b.hour) return a.hour - b.hour;
      return a.order - b.order;
    });
  }, []);

  const getNextDayWithPOIs = (currentDay) => {
    const sortedDays = Object.keys(groupedPOIs).map(Number).sort((a, b) => a - b);
    const nextDayIndex = sortedDays.findIndex(day => day > currentDay);
    return nextDayIndex !== -1 ? sortedDays[nextDayIndex] : null;
  };

  const handlePOIClick = (poi, type) => {
    if (type === 'custom' && isReadOnly) {
      setToastMessage('This operation is only allowed for the owner of the trip, clone this trip if you want to make your own changes');
      setToastType('warning');
      setShowToast(true);
      return;
    }
    
    if (poi.isCustom) {
      setSelectedCustomActivity(poi);
    } else {
      setSelectedPOI(poi);
    }
  };

  const handleCalendarClick = (poi) => {
    setCalendarPOI(poi);
  };

  const handleDateSelect = (date) => {
    if (calendarPOI && date) {
      const dayDiff = Math.floor((date - new Date(dateRange.from)) / (1000 * 60 * 60 * 24)) + 1;
      setItinerary(prevItinerary => ({
        ...prevItinerary,
        pois: prevItinerary.pois.map(poi => 
          poi.uniqueKey === calendarPOI.uniqueKey ? { ...poi, day: dayDiff } : poi
        )
      }));
      setCalendarPOI(null);
      setHasChanges(true);
      setHasUnsavedChanges(true);
    }
  };

  const applyPOIChanges = (uniqueKey, day, hour, duration) => {
    setItinerary(prevItinerary => ({
      ...prevItinerary,
      pois: prevItinerary.pois.map(poi =>
        poi.uniqueKey === uniqueKey ? { ...poi, day, hour, duration } : poi
      )
    }));
    setHasChanges(true);
    setHasUnsavedChanges(true);
  };

  const handleDeletePOIConfirm = async () => {
    try {
      if (!poiToDelete) return;

      if (poiToDelete.isCustom) {
        await deleteCustomActivity(id, poiToDelete.id); // Pass both itineraryId and activityId
        setItinerary(prev => ({
          ...prev,
          pois: prev.pois.filter(poi => poi.uniqueKey !== poiToDelete.uniqueKey)
        }));
      } else {
        // Remove POI from itinerary
        const updatedPois = itinerary.pois.filter(poi => poi.uniqueKey !== poiToDelete.uniqueKey);
        await updateItinerary(id, { ...itinerary, pois: updatedPois });
        setItinerary(prev => ({
          ...prev,
          pois: updatedPois
        }));
      }

      setToastMessage(`${poiToDelete.isCustom ? 'Custom activity' : 'POI'} deleted successfully`);
      setShowToast(true);
    } catch (error) {
      console.error('Error deleting POI:', error);
      setToastMessage(`Failed to delete ${poiToDelete.isCustom ? 'activity' : 'POI'}`);
      setShowToast(true);
    } finally {
      setShowDeletePOIModal(false);
      setPoiToDelete(null);
    }
  };

  const handleDeletePOI = (uniqueKey) => {
    const poi = itinerary.pois.find(p => p.uniqueKey === uniqueKey);
    if (poi) {
      setPoiToDelete(poi);
      setShowDeletePOIModal(true);
    }
  };

  const handleNavigate = () => {
  };

  const formatHour = (hour) => {
    const ampm = hour >= 12 ? ' PM' : ' AM';
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:00${ampm}`;
  };

  const assignDefaultTimes = (pois) => {
    let currentHour = 12;
    return pois.map(poi => {
      if (poi.hour === undefined || poi.hour === null) {
        poi.hour = currentHour;
        currentHour = (currentHour + 1) % 24;
      }
      return poi;
    });
  };

  const handleScroll = useCallback((e) => {
    const scrollPosition = e.target.scrollTop;
    const headerHeight = headerRef.current ? headerRef.current.offsetHeight : 0;

    let newCurrentDay = 1;
    Object.entries(dayRefs.current).forEach(([day, ref]) => {
      if (ref && ref.offsetTop <= scrollPosition + headerHeight) {
        newCurrentDay = parseInt(day);
      }
    });
    setCurrentDay(newCurrentDay);
  }, []);

  const renderDaySelector = () => {
    const days = [];
    if (dateRange.from && dateRange.to) {
      let currentDate = new Date(dateRange.from);
      const endDateObj = new Date(dateRange.to);

      while (currentDate <= endDateObj) {
        days.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }

    return (
      <DaySelectorContainer>
        <DaySelector>
          {days.map((day, index) => (
            <DayButton
              key={index}
              selected={selectedDay === index + 1}
              onClick={() => setSelectedDay(index + 1)}
            >
              <MonthAbbr>{format(day, 'MMM', { locale: language === 'es' ? es : enUS })}</MonthAbbr>
              <DayNumber>{format(day, 'd')}</DayNumber>
            </DayButton>
          ))}
        </DaySelector>
      </DaySelectorContainer>
    );
  };

  const handlePOIResize = async (uniqueKey, newDuration) => {
    const isCustom = uniqueKey.startsWith('custom-');
    const updatedActivities = isCustom ? customActivities : itinerary.pois;
    
    const updatedActivity = updatedActivities.find(activity => activity.uniqueKey === uniqueKey);
    if (updatedActivity) {
      try {
        if (isCustom) {
          const activityId = updatedActivity.id;
          await updateCustomActivity(itinerary.id, activityId, { duration: newDuration });
          
          setCustomActivities(prevActivities => 
            prevActivities.map(activity => 
              activity.id === activityId ? { ...activity, duration: newDuration } : activity
            )
          );
        } else {
          await updateItineraryPOI(itinerary.id, updatedActivity.id, { 
            day: updatedActivity.day,
            hour: updatedActivity.hour,
            duration: newDuration 
          });

          setItinerary(prevItinerary => ({
            ...prevItinerary,
            pois: prevItinerary.pois.map(poi => 
              poi.uniqueKey === uniqueKey ? { ...poi, duration: newDuration } : poi
            )
          }));
        }
      } catch (error) {
        console.error('Error updating activity duration:', error);
        setToastMessage('Failed to update duration');
        setShowToast(true);
      }
    }
  };

  const getPoiColor = (type) => {
    switch (type) {
      case 'restaurant':
        return '#F2C143';
      case 'hotel':
        return '#808080';
      case 'exploration':
        return '#57B2A6';
      case 'task':
        return '#FFA07A';
      case 'rent_a_car':
        return '#FF6347';
      case 'poi':
        return '#4CAF50';
      default:
        return '#87CEEB'; // Changed default to exploration color
    }
  };

  const getPoiIcon = (type) => {
    switch (type) {
      case 'restaurant':
        return faUtensils;
      case 'hotel':
        return faBed;
      case 'exploration':
        return faCompass;
      case 'task':
        return faTasks;
      case 'rent_a_car':
        return faCar;
      case 'poi':
        return faUmbrellaBeach;
      default:
        return faMapMarkerAlt;
    }
  };

  const getDateFromDay = useCallback((day) => {
    if (!dateRange.from) return null;
    return addDays(new Date(dateRange.from), day - 1);
  }, [dateRange]);

  const formatDayNumber = useCallback((day) => {
    const date = getDateFromDay(day);
    return date ? format(date, 'd') : day;
  }, [getDateFromDay]);

  const handlePOIDateChange = async (uniqueKey, newDate) => {
    const dayDiff = Math.floor((newDate - new Date(dateRange.from)) / (1000 * 60 * 60 * 24)) + 1;
    const poiToUpdate = itinerary.pois.find(poi => poi.uniqueKey === uniqueKey);
    
    if (poiToUpdate) {
      try {
        if (poiToUpdate.isCustom) {
          await updateCustomActivity(itinerary.id, poiToUpdate.id, { day: dayDiff });
        } else {
          await updateItineraryPOI(itinerary.id, poiToUpdate.id, { day: dayDiff, hour: poiToUpdate.hour });
        }

        setItinerary(prevItinerary => ({
          ...prevItinerary,
          pois: prevItinerary.pois.map(poi => 
            poi.uniqueKey === uniqueKey ? { ...poi, day: dayDiff } : poi
          )
        }));

        setToastMessage(t.toast.activityDateUpdated);
        setShowToast(true);
      } catch (error) {
        console.error('Error updating activity date:', error);
        setToastMessage(t.toast.activityDateError);
        setShowToast(true);
      }
    }
  };

  const handleHourChange = (uniqueKey, newHour) => {
    setEditingPOI(prev => ({ ...prev, hour: newHour }));
  };

  const handleDurationChange = (uniqueKey, newDuration) => {
    setEditingPOI(prev => ({ ...prev, duration: newDuration }));
  };

  const handleClonePOI = async (poi) => {
    try {
      let clonedItem;
      if (poi.isCustom) {
        clonedItem = await cloneCustomActivity(itinerary.id, poi.id);
      } else {
        clonedItem = await clonePOI(itinerary.id, poi.id);
      }
      
      // The cloned item will now always be a custom activity
      const newPOI = {
        ...clonedItem,
        uniqueKey: clonedItem.uniqueKey || `custom-${clonedItem.id}-${Date.now()}`,
        isCustom: true
      };

      setItinerary(prevItinerary => ({
        ...prevItinerary,
        pois: [...prevItinerary.pois, newPOI]
      }));
      
      setToastMessage('Activity copied successfully');
      setShowToast(true);
    } catch (error) {
      console.error('Error copying activity:', error);
      setToastMessage('Failed to copy activity. Please try again.');
      setShowToast(true);
    }
  };

  const handleTimeSlotClick = (day, hour) => {
    if (isReadOnly) {
      setToastMessage('This operation is only allowed for the owner of the trip, clone this trip if you want to make your own changes');
      setToastType('warning');
      setShowToast(true);
      return;
    }
    setSelectedTimeSlot({ day, hour });
    setShowCustomActivityModal(true);
  };

  const handleCustomActivitySave = async (activityData) => {
    try {
      const response = await createCustomActivity(id, {
        ...activityData,
        day: selectedTimeSlot.day,
        hour: selectedTimeSlot.hour,
        order: getNextOrder(selectedTimeSlot.day, selectedTimeSlot.hour),
      });
      
      const newActivity = {
        ...response,
        isCustom: true,
        uniqueKey: `custom-${response.id}`,
        // Add these properties to match POI structure
        day: selectedTimeSlot.day,
        hour: selectedTimeSlot.hour,
        duration: 1
      };

      // Update both the customActivities and the itinerary's pois
      setCustomActivities(prevActivities => [...prevActivities, newActivity]);
      setItinerary(prevItinerary => ({
        ...prevItinerary,
        pois: [...prevItinerary.pois, newActivity]
      }));

      setShowCustomActivityModal(false);
      setToastMessage('Activity added successfully');
      setShowToast(true);
      
    } catch (error) {
      console.error('Error creating activity:', error);
      setToastMessage('Failed to add activity');
      setShowToast(true);
      setHasUnsavedChanges(true);
    }
  };

  const getNextOrder = (day, hour) => {
    const existingActivities = [...(itinerary?.pois || []), ...customActivities];
    const activitiesInSlot = existingActivities.filter(
      activity => activity.day === day && activity.hour === hour
    );
    return activitiesInSlot.length + 1;
  };

  const renderTimeSlot = (hour) => {
    const slotActivities = itinerary?.pois?.filter(activity => 
      activity.day === selectedDay && activity.hour === hour
    ) || [];

    return (
      <Droppable droppableId={`day-${selectedDay}-${hour}`} key={`${selectedDay}-${hour}`}>
        {(provided, snapshot) => (
          <TimeSlot ref={provided.innerRef} {...provided.droppableProps}>
            <TimeSlotHeader>{formatHour(hour)}</TimeSlotHeader>
            <POIContainer>
              {slotActivities.map((activity, index) => (
                <ResizablePOICard
                  key={activity.uniqueKey || `${activity.id}-${activity.day}-${activity.hour}-${index}`}
                  poi={activity}
                  index={index}
                  onResize={handlePOIResize}
                  onDelete={() => handleDeletePOI(activity.uniqueKey)}
                  onNavigate={handleNavigate}
                  onClick={handlePOIClick}
                  onClone={handleClonePOI}
                  onCalendarClick={handleCalendarClick}
                  backgroundColor={getPoiColor(activity.type)}
                  icon={getPoiIcon(activity.type)}
                  height={`${Math.max(1, activity.duration || 1) * 60}px`}
                  marginTop={`${(activity.hour - hour) * 60}px`}
                  totalActivities={slotActivities.length}
                  activityIndex={index}
                  isReadOnly={isReadOnly}
                />
              ))}
              {provided.placeholder}
              {slotActivities.length === 0 && !isReadOnly && (
                <EmptyTimeSlot onClick={() => handleTimeSlotClick(selectedDay, hour)}>
                  <GhostCard className="ghost-card">
                    Click here to create custom activity
                  </GhostCard>
                </EmptyTimeSlot>
              )}
            </POIContainer>
          </TimeSlot>
        )}
      </Droppable>
    );
  };

  const renderSelectedDay = () => {
    return (
      <div className={styles.selectedDayContent}>
        <div className={styles.dayContent} ref={el => dayRefs.current[selectedDay] = el}>
          {Array.from({ length: 24 }, (_, i) => renderTimeSlot(i))}
        </div>
      </div>
    );
  };

  const formatDateRange = useCallback((start, end) => {
    if (!start || !end) return '';
    return `${format(start, 'MMM d, yyyy', { locale: language === 'es' ? es : enUS })} - ${format(end, 'MMM d, yyyy', { locale: language === 'es' ? es : enUS })}`;
  }, [language]);

  const handleAddPOI = async (newPOI) => {
    try {
      await addPOIToTrip(itinerary.id, newPOI.id);
      const updatedItinerary = await getItineraryById(id);
      setItinerary(updatedItinerary);
      setToastMessage(t.toast.activityAdded);
      setShowToast(true);
    } catch (error) {
      console.error('Error adding activity to trip:', error);
      setToastMessage(t.toast.activityAddError);
      setShowToast(true);
    }
  };

  const memoizedItineraryMap = useMemo(() => {
    if (itinerary && amenities) {
      return (
        <TripMap
          pois={itinerary?.pois || []}
          amenities={amenities}
          hasUnsavedChanges={hasUnsavedChanges}
          onAddPOI={handleAddPOI}
        />
      );
    }
    return null;
  }, [itinerary, amenities, hasUnsavedChanges, handleAddPOI]);

  const adjustDatePickerPosition = () => {
    const datePickerPopover = document.querySelector(`.${styles.datePickerPopover}`);
    if (datePickerPopover) {
      const rect = datePickerPopover.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      if (spaceBelow < 0) {
        datePickerPopover.style.top = 'auto';
        datePickerPopover.style.bottom = '100%';
        datePickerPopover.style.marginTop = '0';
        datePickerPopover.style.marginBottom = '5px';
      }
    }
  };

  useEffect(() => {
    if (isDatePickerOpen) {
      adjustDatePickerPosition();
    }
  }, [isDatePickerOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        if (editingPOI) {
          const { uniqueKey, day, hour, duration } = editingPOI;
          applyPOIChanges(uniqueKey, day, hour, duration);
          setEditingPOI(null);
          setShowPopup(null);
        }
      }
    };

    if (editingPOI) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [editingPOI]);

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await deleteItinerary(id);
      localStorage.setItem('toastMessage', 'Trip deleted successfully');
      history.push('/my-trips');
    } catch (error) {
      console.error('Error deleting trip:', error);
      setToastMessage('Failed to delete trip. Please try again.');
      setShowToast(true);
    }
    setShowDeleteModal(false);
  };

  const handleCloneClick = async () => {
    try {
      const clonedTrip = await cloneItinerary(id);
      setToastMessage('Trip copied successfully');
      setToastType('success');
      setShowToast(true);
      
      window.open(`/trip/${clonedTrip.id}`, '_blank');
    } catch (error) {
      console.error('Error copying trip:', error);
      setToastMessage('Failed to copy trip. Please try again.');
      setToastType('error');
      setShowToast(true);
    }
  };

  useEffect(() => {
    return () => {
      if (mapContainerRef.current) {
        mapContainerRef.current.innerHTML = '';
      }
    };
  }, [itinerary]);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleConfirmChanges = async () => {
    try {
      await updateItinerary(id, pendingChanges);
      setItinerary(prev => ({ ...prev, ...pendingChanges }));
      setToastMessage('Changes saved successfully');
      setShowToast(true);
    } catch (error) {
      console.error('Error saving changes:', error);
      setToastMessage('Failed to save changes. Please try again.');
      setShowToast(true);
    }
    setShowConfirmModal(false);
    setPendingChanges(null);
  };

  const handleCancelChanges = () => {
    if (pendingChanges.name) {
      setTitle(itinerary.name);
    }
    if (pendingChanges.start_date || pendingChanges.end_date) {
      setDateRange({ from: new Date(itinerary.start_date), to: new Date(itinerary.end_date) });
    }
    setShowConfirmModal(false);
    setPendingChanges(null);
  };

  const scrollToPosition = useCallback((position) => {
    if (scrollableContentRef.current) {
      scrollableContentRef.current.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    }
  }, []);

  const calculateScrollPosition = useCallback((day) => {
    if (!dateRange.from || !dateRange.to) return 0;

    const startDate = startOfDay(new Date(dateRange.from));
    const currentDate = addDays(startDate, day - 1);
    const now = new Date();

    // If current date is not within the trip dates, don't scroll
    if (currentDate < startDate || currentDate > dateRange.to) return 0;

    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    // Calculate position based on hours and minutes
    const hourHeight = 60; // 60px per hour
    const minuteHeight = 1; // 1px per minute

    return (currentHour * hourHeight) + (currentMinute * minuteHeight);
  }, [dateRange]);

  // Add this function definition
  const findFirstCardOfDay = useCallback((day) => {
    if (!itinerary) return null;
    const allActivities = [...(itinerary.pois || []), ...customActivities];
    return allActivities.find(activity => activity.day === day);
  }, [itinerary, customActivities]);

  // Modify the existing effect to use findFirstCardOfDay
  useEffect(() => {
    const scrollToAppropriatePosition = () => {
      if (scrollableContentRef.current && itinerary) {
        const firstCard = findFirstCardOfDay(selectedDay);
        if (firstCard) {
          const hourOffset = firstCard.hour * 60; // 60px per hour
          scrollToPosition(hourOffset - 20); // 20px offset for better visibility
        } else {
          const scrollPosition = calculateScrollPosition(selectedDay);
          scrollToPosition(scrollPosition);
        }
      }
    };

    // Delay the scroll to ensure the content is rendered
    const timeoutId = setTimeout(scrollToAppropriatePosition, 100);

    return () => clearTimeout(timeoutId);
  }, [itinerary, selectedDay, findFirstCardOfDay, scrollToPosition, calculateScrollPosition]);

  const handleSettingsClick = () => {
    if (isReadOnly) {
      setToastMessage('This operation is only allowed for the owner of the trip, clone this trip if you want to make your own changes');
      setToastType('warning');
      setShowToast(true);
      return;
    }
    
    // Initialize settings state with current values
    setSettingsTitle(title);
    setSettingsDateRange({
      from: new Date(dateRange.from),
      to: new Date(dateRange.to)
    });
    setSettingsIsPublic(itinerary.isPublic);
    setShowSettingsModal(true);
  };

  const handleSettingsSave = async () => {
    try {
      const updatedItinerary = await updateItinerary(id, {
        name: settingsTitle,
        start_date: settingsDateRange?.from || dateRange.from,
        end_date: settingsDateRange?.to || dateRange.to,
        isPublic: settingsIsPublic
      });
      
      setTitle(updatedItinerary.name);
      setDateRange({
        from: new Date(updatedItinerary.start_date),
        to: new Date(updatedItinerary.end_date)
      });
      setItinerary(prev => ({
        ...prev,
        isPublic: updatedItinerary.isPublic
      }));
      setShowSettingsModal(false);
      setHasUnsavedChanges(false);
      setToastMessage('Trip updated successfully');
      setShowToast(true);
      
      reorganizePOIs(updatedItinerary.start_date, updatedItinerary.end_date);
    } catch (error) {
      console.error('Error updating trip:', error);
      setToastMessage('Failed to update trip');
      setShowToast(true);
    }
  };

  const handleSettingsInputChange = (e) => {
    setSettingsTitle(e.target.value);
    setHasUnsavedChanges(true);
  };

  const handleSettingsDateChange = (range) => {
    setSettingsDateRange(range);
    setHasUnsavedChanges(true);
  };

  const handlePublicChange = (checked) => {
    setSettingsIsPublic(checked);
    setHasUnsavedChanges(true);
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const handleShareItinerary = () => {
    // Implement sharing functionality here
    console.log('Share itinerary');
    // For now, let's just show a toast message
    setToastMessage('Sharing functionality coming soon!');
    setShowToast(true);
  };

  const totalActivities = useMemo(() => {
    return (itinerary?.pois?.length || 0) + (customActivities?.length || 0);
  }, [itinerary, customActivities]);

  const handleUpdateCustomActivity = async (updatedActivity) => {
    try {
      await updateCustomActivity(id, updatedActivity.id, {
        name: updatedActivity.name,
        description: updatedActivity.description,
        type: updatedActivity.type,
        duration: updatedActivity.duration,
        day: updatedActivity.day,
        hour: updatedActivity.hour,
        lat: updatedActivity.lat,
        lng: updatedActivity.lng,
        order: updatedActivity.order
      });

      // Update the itinerary state with the updated activity
      setItinerary(prev => ({
        ...prev,
        pois: prev.pois.map(poi => 
          poi.uniqueKey === updatedActivity.uniqueKey ? { ...poi, ...updatedActivity } : poi
        )
      }));
      
      setToastMessage('Activity updated successfully');
      setShowToast(true);
    } catch (error) {
      console.error('Error updating custom activity:', error);
      setToastMessage('Failed to update activity');
      setShowToast(true);
    }
  };

  const handleSocialShare = (platform) => {
    const baseUrl = window.location.origin;
    const tripUrl = `${baseUrl}/trip/${id}`;
    const shareText = `Check out my trip: ${title}!`;

    switch (platform) {
      case 'whatsapp':
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const whatsappUrl = isMobile
          ? `whatsapp://send?text=${encodeURIComponent(`${shareText}\n${tripUrl}`)}`
          : `https://web.whatsapp.com/send?text=${encodeURIComponent(`${shareText}\n${tripUrl}`)}`;
        window.open(whatsappUrl, '_blank');
        break;
      case 'twitter':
        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(tripUrl)}&hashtags=Travel`,
          '_blank'
        );
        break;
      case 'email':
        window.location.href = `mailto:?subject=${encodeURIComponent(`Check out my trip: ${title}`)}&body=${encodeURIComponent(`${shareText}\n\n${tripUrl}`)}`;
        break;
      case 'copy':
        navigator.clipboard.writeText(`${shareText}\n${tripUrl}`).then(() => {
          setToastMessage('Link copied to clipboard!');
          setToastType('success');
          setShowToast(true);
        });
        break;
      default:
        break;
    }
  };

  const handleClonePublicTrip = async () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      setPendingAction('cloneTrip');
      return;
    }

    try {
      await executeCloneTrip();
    } catch (error) {
      console.error('Error copying trip:', error);
      setToastMessage('Failed to copy trip. Please try again.');
      setToastType('error');
      setShowToast(true);
    }
  };

  // Separate the clone execution logic
  const executeCloneTrip = async () => {
    const clonedTrip = await cloneItinerary(id);
    setToastMessage('Trip copied successfully');
    setToastType('success');
    setShowToast(true);
    
    setTimeout(() => {
      history.push(`/trip/${clonedTrip.id}`);
    }, 1500);
  };

  const handleAuthSuccess = async (user, token) => {
    login(user, token);
    setShowAuthModal(false);

    // If there was a pending clone action, execute it immediately
    if (pendingAction === 'cloneTrip') {
      try {
        await executeCloneTrip();
      } catch (error) {
        console.error('Error executing pending clone:', error);
        setToastMessage('Failed to copy trip. Please try again.');
        setToastType('error');
        setShowToast(true);
      }
      setPendingAction(null);
    }
  };

  // Update the premium user check
  const isPremiumUser = useMemo(() => {
    return user?.subscription_status === 'premium';
  }, [user]);

  // Add some debug logging
  useEffect(() => {
    console.log('User subscription status:', user?.subscription);
    console.log('Is premium user:', isPremiumUser);
  }, [user, isPremiumUser]);

  if (!itinerary || !dateRange.from || !dateRange.to) return <div>{t.loading}</div>;

  const sortedPOIs = sortPOIs(assignDefaultTimes(itinerary.pois));
  const groupedPOIs = sortedPOIs.reduce((acc, poi) => {
    const day = poi.day || 1;
    if (!acc[day]) acc[day] = [];
    acc[day].push(poi);
    return acc;
  }, {});

  return (
    <PageWrapper>
      <Prompt
        when={hasUnsavedChanges}
        message={t.unsavedChanges.message}
      />
      <Navbar />
      <ContentContainer>
        <MapAndItineraryContainer>
          <MapAndHeaderContainer>
            <HeaderSection>
              <HeaderContainer ref={headerRef}>
                <SettingsContainer>
                  <ShareButton>
                    <FontAwesomeIcon icon={faShare} />
                    {itinerary?.isPublic ? (
                      <SharePopup>
                        <SocialIcon 
                          className="whatsapp" 
                          onClick={() => handleSocialShare('whatsapp')}
                          title={t.share.whatsapp}
                        >
                          <FontAwesomeIcon icon={faWhatsapp} />
                        </SocialIcon>
                        <SocialIcon 
                          className="twitter" 
                          onClick={() => handleSocialShare('twitter')}
                          title={t.share.twitter}
                        >
                          <FontAwesomeIcon icon={faXTwitter} />
                        </SocialIcon>
                        <SocialIcon 
                          className="email" 
                          onClick={() => handleSocialShare('email')}
                          title={t.share.email}
                        >
                          <FontAwesomeIcon icon={faEnvelope} />
                        </SocialIcon>
                        <SocialIcon 
                          className="copy" 
                          onClick={() => handleSocialShare('copy')}
                          title={t.share.copy}
                        >
                          <FontAwesomeIcon icon={faLink} />
                        </SocialIcon>
                      </SharePopup>
                    ) : (
                      <PrivateMessage>
                        {t.share.privateMessage}
                      </PrivateMessage>
                    )}
                  </ShareButton>
                  <SettingsButton onClick={handleSettingsClick}>
                    <FontAwesomeIcon icon={faCog} />
                  </SettingsButton>
                </SettingsContainer>
                <TitleSection>
                  <TripTitle title={title}>{title}</TripTitle>
                  <SubtitleSection>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TripDateRange>
                        {formatDateRange(dateRange.from, dateRange.to)}
                      </TripDateRange>
                      <HeaderButtonsContainer>
                        <HeaderButton onClick={() => setShowBudgetModal(true)}>
                          <FontAwesomeIcon icon={faWallet} style={{ color: '#F38530' }} />
                          {t.budget}
                        </HeaderButton>
                        <HeaderButton onClick={() => setShowChecklistModal(true)}>
                          <FontAwesomeIcon icon={faListCheck} style={{ color: '#F38530' }} />
                          {t.checklist}
                        </HeaderButton>
                      </HeaderButtonsContainer>
                    </div>
                  </SubtitleSection>
                </TitleSection>
                <CSSTransition
                  in={isDatePickerOpen}
                  timeout={300}
                  classNames="calendar"
                  unmountOnExit
                >
                  <DatePickerContainer ref={calendarRef}>
                    <DayPicker
                      mode="range"
                      selected={dateRange}
                      onSelect={handleDateChange}
                      numberOfMonths={1}
                      defaultMonth={dateRange.from || new Date()}
                      locale={language === 'es' ? es : enUS}
                    />
                  </DatePickerContainer>
                </CSSTransition>
              </HeaderContainer>
            </HeaderSection>
            
            <MapSection>
              <MapWrapper>
                <ErrorBoundary>
                  <ItineraryMap 
                    pois={itinerary.pois} 
                    amenities={amenities}
                    onUpdateCustomActivity={handleUpdateCustomActivity}
                    isReadOnly={isReadOnly}
                  />
                </ErrorBoundary>
              </MapWrapper>
            </MapSection>
          </MapAndHeaderContainer>

          <ItinerarySection>
            <div className={styles.itineraryContent}>
              <HeaderContainer ref={headerRef}>
                <div className={styles.daySelectorWrapper}>
                  <div className={styles.daySelector}>
                    {renderDaySelector()}
                  </div>
                </div>
              </HeaderContainer>
              <ScrollableContent ref={scrollableContentRef}>
                <DragDropContext 
                  onDragEnd={handleDragEnd} 
                  isDragDisabled={isReadOnly}
                >
                  {renderSelectedDay()}
                </DragDropContext>
              </ScrollableContent>
            </div>
          </ItinerarySection>

          <RightAdContainer>
            <VerticalAdBanner />
          </RightAdContainer>
        </MapAndItineraryContainer>
      </ContentContainer>
      {showToast && (
        <Toast
          message={toastMessage}
          onClose={() => setShowToast(false)}
          type={toastMessage.includes('successfully') ? 'success' : 'error'}
        />
      )}
      {selectedPOI && !selectedPOI.isCustom && (
        <POIDetails 
          poi={selectedPOI} 
          onClose={() => setSelectedPOI(null)} 
          amenities={amenities}
          isModal={true}
        />
      )}
      {selectedCustomActivity && (
        <CustomActivityDetailsModal
          activity={selectedCustomActivity}
          onClose={() => setSelectedCustomActivity(null)}
          onUpdate={handleUpdateCustomActivity}
          isReadOnly={isReadOnly}
        />
      )}
      {showDeleteModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>{t.confirmDelete.title}</h2>
            <p>{t.confirmDelete.message}</p>
            <div className={styles.modalButtons}>
              <Button onClick={() => setShowDeleteModal(false)}>{t.confirmDelete.cancel}</Button>
              <Button danger onClick={handleDeleteConfirm}>{t.confirmDelete.confirm}</Button>
            </div>
          </div>
        </div>
      )}
      {calendarPOI && (
        <div className={styles.modalOverlay} onClick={() => setCalendarPOI(null)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <DayPicker
              mode="single"
              selected={getDateFromDay(calendarPOI.day)}
              onSelect={(date) => {
                if (date) {
                  handlePOIDateChange(calendarPOI.uniqueKey, date);
                }
                setCalendarPOI(null);
              }}
              fromDate={new Date(dateRange.from)}
              toDate={new Date(dateRange.to)}
              defaultMonth={startOfMonth(getDateFromDay(calendarPOI.day) || new Date(dateRange.from))}
            />
          </div>
        </div>
      )}
      {showCustomActivityModal && (
        <CustomActivityModal
          onClose={() => setShowCustomActivityModal(false)}
          onSave={handleCustomActivitySave}
          selectedTimeSlot={selectedTimeSlot}
        />
      )}
      {showConfirmModal && (
        <ConfirmModal>
          <ConfirmContent>
            <h3>{t.unsavedChanges.title}</h3>
            <p>{t.unsavedChanges.message}</p>
            <ConfirmButtons>
              <Button onClick={handleCancelChanges}>{t.unsavedChanges.cancel}</Button>
              <Button onClick={handleConfirmChanges}>{t.unsavedChanges.confirm}</Button>
            </ConfirmButtons>
          </ConfirmContent>
        </ConfirmModal>
      )}
      {showSettingsModal && (
        <SettingsModal
          show={showSettingsModal}
          onClose={() => setShowSettingsModal(false)}
          title={settingsTitle || title}
          dateRange={{
            from: settingsDateRange?.from || dateRange.from,
            to: settingsDateRange?.to || dateRange.to
          }}
          isPublic={settingsIsPublic}
          onTitleChange={handleSettingsInputChange}
          onDateChange={handleSettingsDateChange}
          onPublicChange={handlePublicChange}
          onSave={handleSettingsSave}
          onDelete={handleDeleteClick}
          onClone={handleCloneClick}
          hasUnsavedChanges={hasUnsavedChanges}
        />
      )}
      {showDeletePOIModal && (
        <ConfirmModal>
          <ConfirmContent>
            <h3>{t.confirmDeletePOI.title.replace('{type}', poiToDelete?.isCustom ? 'Custom Activity' : 'POI')}</h3>
            <p>{t.confirmDeletePOI.message.replace('{name}', poiToDelete?.name || '')}</p>
            <ConfirmButtons>
              <Button onClick={() => setShowDeletePOIModal(false)}>{t.confirmDeletePOI.cancel}</Button>
              <Button danger onClick={handleDeletePOIConfirm}>{t.confirmDeletePOI.confirm}</Button>
            </ConfirmButtons>
          </ConfirmContent>
        </ConfirmModal>
      )}
      {showBudgetModal && (
        <BudgetOverviewModal
          itinerary={itinerary}
          bookings={itinerary.Bookings || []}
          onClose={() => setShowBudgetModal(false)}
          isChecklistOpen={showChecklistModal}
        />
      )}
      {showChecklistModal && (
        <ChecklistModal
          itineraryId={itinerary.id}
          onClose={() => setShowChecklistModal(false)}
          isBudgetOpen={showBudgetModal}
        />
      )}
      {showAuthModal && (
        <AuthModal 
          onClose={() => {
            setShowAuthModal(false);
            setPendingAction(null);
          }}
          onAuthSuccess={handleAuthSuccess}
        />
      )}

    </PageWrapper>
  );
};

export default TripDetailsPage;